import * as Types from '../Constants/AllConstants';

const mutationRequests = new Set([
  Types.TOURNAMENT_GROUP_SETUP_REQUEST,
  Types.TOURNAMENT_GROUP_FIXTURES_REQUEST,
  Types.TOURNAMENT_QUALIFICATION_REQUEST,
  Types.TOURNAMENT_BRACKET_REQUEST,
  Types.TOURNAMENT_RECALCULATE_REQUEST,
]);

const mutationSuccesses = new Set([
  Types.TOURNAMENT_GROUP_SETUP_SUCCESS,
  Types.TOURNAMENT_GROUP_FIXTURES_SUCCESS,
  Types.TOURNAMENT_QUALIFICATION_SUCCESS,
  Types.TOURNAMENT_BRACKET_SUCCESS,
  Types.TOURNAMENT_RECALCULATE_SUCCESS,
]);

const mutationFails = new Set([
  Types.TOURNAMENT_GROUP_SETUP_FAIL,
  Types.TOURNAMENT_GROUP_FIXTURES_FAIL,
  Types.TOURNAMENT_QUALIFICATION_FAIL,
  Types.TOURNAMENT_BRACKET_FAIL,
  Types.TOURNAMENT_RECALCULATE_FAIL,
]);

export const TournamentStateReducer = (state = { tournament: null, loading: false, actionLoading: false }, action) => {
  switch (action.type) {
    case Types.TOURNAMENT_STATE_REQUEST:
      return { ...state, loading: true, error: null };
    case Types.TOURNAMENT_STATE_SUCCESS:
      return { ...state, loading: false, tournament: action.payload, error: null };
    case Types.TOURNAMENT_STATE_FAIL:
      return { ...state, loading: false, error: action.payload };
    case Types.TOURNAMENT_RESET:
      return { tournament: null, loading: false, actionLoading: false };
    default:
      if (mutationRequests.has(action.type)) {
        return { ...state, actionLoading: true, success: false, error: null };
      }
      if (mutationSuccesses.has(action.type)) {
        return { ...state, actionLoading: false, success: true, tournament: action.payload, error: null };
      }
      if (mutationFails.has(action.type)) {
        return { ...state, actionLoading: false, success: false, error: action.payload };
      }
      return state;
  }
};
